import React, { useContext, useEffect, useState } from 'react'
import { getImages } from '../Components/const';
import { VehicleContext } from '../Components/Context/VehicleContext';
import ModalLayout from '../Components/Common/ModalLayout';
import SelectFilterModal from '../Components/Srp/SelectFilterModal';
import UseScrollReveal from '../Components/Common/UseScrollReveal ';
import { Link } from 'react-router-dom';
import SeoMeta from '../Components/Common/SeoMeta';

const LeaseSpecials = () => {
  const [vehicleSearchText, setVehicleSearchText] = useState("");
      const {getVehicleData, vehicleData, filteredVehicleData, priceFormatter, currentFilterData, setCurrentFilterData} = useContext(VehicleContext);
      const searchInputChanged = (val) => {
          setVehicleSearchText(val);
      }
      const handleFilterBtn = () => {
      }
      const [bgImage, setBgImage] = useState("");
      useEffect(() => {
          // const randomIndex = Math.floor(Math.random() * images.length);
          // setBgImage(images[randomIndex]);
  
          if(!vehicleData) getVehicleData();
      }, []);
      const queryParameters = new URLSearchParams(window.location.search);
      const vehicleMake = queryParameters.get("make");
      // console.log("vehicleMake", vehicleMake)
      useEffect(() => {
          if(vehicleMake) {
              // console.log("currentFilterData", currentFilterData)
              const filter_data = currentFilterData.make.map((v,i) => {
                  return v.name.toLowerCase() == vehicleMake.toLowerCase() ? {...v,"isSelected" : true} : v;
              });
  
              setCurrentFilterData({ ...currentFilterData, ["make"]: filter_data });
  
          }

          const leaseSpecials = filteredVehicleData ? filteredVehicleData.filter(item => item.inventory_manage.lease_special) : [];

          if(filteredVehicleData && leaseSpecials.length == 0) window.location.href = '/inventory/new';
      },[vehicleMake,vehicleData]);
  
      const [filerOptionsOpen, setFilerOptionsOpen] = useState(false);
      const handleMobFilterBtn = () => {
          setFilerOptionsOpen(true)
      }
      const closeSrpFilter = () => {
          setFilerOptionsOpen(false)
      }
  
      // Filter Modal
      
      const [openFilterModal, setOpenFilterModal] = useState(false);
  
      const [filterData, setFilterData] = useState("");
      const [activeFilter,setActiveFilter] = useState("");
      const handleFilterModal = (field) => {
          setOpenFilterModal(true);
  
          setFilterData(currentFilterData[field]);
  
          // setActiveFilter(field);
      }
  
      const closeMakeModal = () => {
          setOpenFilterModal(false)
      }
  
      const updateFilter = (filter_data) => {
          setCurrentFilterData({ ...currentFilterData, [activeFilter]: filter_data });
      }
      // console.log("currentFilterData LS", currentFilterData)
      UseScrollReveal();
  return (
    <>
      <SeoMeta
          title="Lease Specials | Official McLaren Dealer in Orlando, FL | McLaren Orlando"
          description="Browse our current McLaren lease and finance offers available at McLaren Orlando and visit our dealership today. Contact a McLaren specialist today!"
          keywords=""
          ogTitle="Lease Specials | Official McLaren Dealer in Orlando, FL | McLaren Orlando"
          ogDescription="Browse our current McLaren lease and finance offers available at McLaren Orlando and visit our dealership today. Contact a McLaren specialist today!"
      />
      <section className='common-top-wrap pt-140'>
        <div className='container'>
          <div className='d-flex align-items-center justify-content-between search-flex mb-3 wow reveal fadeIn'>
            <div className='d-flex align-items-center ls-search-flex'>
              <div className='d-flex search-box'>
                <input type='text' className='form-control'
                  placeholder='Search'
                  value={vehicleSearchText}
                  onChange={(e) => { searchInputChanged(e.target.value) }}
                />
                <button className='search-btn'><span className='search-icon'></span></button>
              </div>
              <div className="d-lg-none ls-mob-filter-btn">
                  <button type="button" className="filter-btn" onClick={handleMobFilterBtn}>
                      Filters 
                      <img alt="icon" src={getImages('filter_icon.svg')}/>
                  </button>
              </div>
            </div>
            <div className={`d-lg-inline-flex align-items-start srp-filter-block ${filerOptionsOpen ? '' : 'd-none'}`}>
              <div className='srp-filter-header d-lg-none'>
                <div>Filters</div>
                <button className='sf-close-icon' onClick={closeSrpFilter} type='button'><img src={getImages('cross_icon.svg')} /></button>
              </div>
              <div className='srp-filter-body d-inline-flex gap-3'>
                <div className='d-lg-none mb-2'>
                  <div className='sm-title text-start mb-1'>Applied Filters</div>
                  <div className='d-flex align-items-center fl-tags'>
                    <div className='fl-tag'><span>2022-2023</span> <button type='button' className='close-icon'></button></div>
                    <div className='fl-tag'><span>1k-20k</span> <button type='button' className='close-icon'></button></div>
                  </div>
                </div>
                <button type='button' className='fl-btn' onClick={() => handleFilterModal('year')}>
                    <img src={getImages('year-icon.png')}/> 
                    <span>Year</span>
                </button>
                <button type='button' className='fl-btn' onClick={() => handleFilterModal('make')}>
                    <img src={getImages('make-icon.png')}/> 
                    <span>Make</span>
                </button>
                <button type='button' className='fl-btn' onClick={() => handleFilterModal('model')}>
                    <img src={getImages('model-icon.png')}/>
                    <span>Model</span>
                </button>
                <button type='button' className='fl-btn' onClick={() => handleFilterModal('trim')}>
                    <img src={getImages('trim-icon.png')}/> 
                    <span>Trim</span>
                </button>
                {/* <button type='button' className='fl-btn' onClick={() => handleFilterModal('more')}>
                    <img src={getImages('more-icon.png')}/> 
                    <span>More</span>
                </button> */}
              </div>
            </div>
          </div>
          <h4 className='xs-title fw-bold text-orange text-uppercase mt-5 wow reveal fadeIn'>Take advantange of our</h4>
          <h1 className='lg-title text-uppercase mt-1 wow reveal fadeIn'>Lease & New Vehicle Specials</h1>
        </div>
      </section>
      <section className='common-wrap'>
        <div className='container'>
          <div className='row g-32'>
            {filteredVehicleData && filteredVehicleData.filter(item => item.inventory_manage.lease_special).map((item, index) =>
              <div className='col-lg-4 col-md-6 col-12 wow reveal fadeIn' key={index}>
                <div className='ls-box'>
                  <div className='ls-image'>
                    <Link to={"/vehicle-details/" + item.vdp_url}><img src={item.images[0]} alt='lease special' /></Link>
                  </div>
                  <div className='ls-content'>
                    <div className='d-flex align-items-center mb-2 justify-content-between'>
                      <div className='xs-title font-1-2em text-orange text-uppercase fw-bold'>Lease Special</div>
                      <div className='mb-1'>
                        <button className='info-icon'>
                          <img src={getImages('info-icon.svg')} alt='icon' />
                        </button>
                      </div>
                    </div>
                    <div className='xs-title font-1-1em mb-1 title-ellipsis'>{item.vehicle_name}</div>
                    <div className='d-flex align-items-center'>
                      <span className='fv-price font-2em'>{priceFormatter(item.inventory_manage.price_per_month,true)}</span>
                      <span className='fv-mileage font-0-9em ps-3 d-inline-block'>Per Month</span>
                    </div>
                    <div className='ls-text'>
                      {/*<p>Lease offer valid thru Nov 30, 2025. As advertised lorem ipsum semper duet with har daus kradem… <span className='text-orange'>More details</span></p>*/}
                      <p>{item.inventory_manage.description}</p>
                      <p>{item.inventory_manage.disclaimer}</p>
                    </div>
                    <div className='text-center'>
                      <Link to={"/vehicle-details/" + item.vdp_url} className='theme-btn text-uppercase'>View Details</Link>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
      {openFilterModal &&
          <ModalLayout open={openFilterModal} close={closeMakeModal} darkThemeCls='true' modalWidth={970}>
              <SelectFilterModal close={closeMakeModal} filterData={filterData} updateFilter={updateFilter} activeFilter={activeFilter} />
          </ModalLayout>
      }
    </>
  )
}

export default LeaseSpecials